import { render } from "./ChangeToApprovalModal.vue?vue&type=template&id=0625da1f&scoped=true"
import script from "./ChangeToApprovalModal.vue?vue&type=script&lang=js"
export * from "./ChangeToApprovalModal.vue?vue&type=script&lang=js"

import "./ChangeToApprovalModal.vue?vue&type=style&index=0&id=0625da1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0625da1f"],['__file',"src/components/ChangeToApprovalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0625da1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0625da1f', __exports__)) {
    api.reload('0625da1f', __exports__)
  }
  
  module.hot.accept("./ChangeToApprovalModal.vue?vue&type=template&id=0625da1f&scoped=true", () => {
    api.rerender('0625da1f', render)
  })

}


export default __exports__